export function importAll(r) {
  let allImgs = {}
   r.keys().map((item, index) => {
       allImgs[item.replace('./', '')] = r(item).default;
   });
  return allImgs;
}